module.exports = __webpack_public_path__ + "4aac4e1b70b79f39b284b78a8cfd4644.MP3";